/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type WishItemToggle_plant$ref: FragmentReference;
declare export opaque type WishItemToggle_plant$fragmentType: WishItemToggle_plant$ref;
export type WishItemToggle_plant = {|
  +id: string,
  +title: string,
  +myWishItem: ?{|
    +id: string
  |},
  +$refType: WishItemToggle_plant$ref,
|};
export type WishItemToggle_plant$data = WishItemToggle_plant;
export type WishItemToggle_plant$key = {
  +$data?: WishItemToggle_plant$data,
  +$fragmentRefs: WishItemToggle_plant$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "WishItemToggle_plant",
  "type": "LifeNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "myWishItem",
      "storageKey": null,
      "args": null,
      "concreteType": "WishItem",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '0ccced4b9410e1e986669d651d46bc6f';
module.exports = node;
